module.exports = __webpack_public_path__ + "img/shape-or-container.64ec557b.png";